/**
 * Normalizes bulk-order API responses into a consistent UI result.
 *
 * Success (80): { success: true, uiMessage, taskId, ordersQueued }
 * Error (90):   { success: false, uiMessage, fileError?, validationErrors? }
 */
export const parseBulkOrderResponse = (payload = {}) => {
  const {
    response_code: responseCode,
    ui_message: uiMessage,
    data = {},
    error,
  } = payload;

  if (responseCode === 80) {
    return {
      success: true,
      uiMessage: uiMessage || "Bulk order creation started.",
      taskId: data.task_id || null,
      ordersQueued: data.orders_queued != null ? data.orders_queued : null,
    };
  }

  // Field-level file errors: { file: "..." }
  if (error && !Array.isArray(error) && typeof error === "object") {
    const fileError = error.file || Object.values(error).find(Boolean) || null;
    return {
      success: false,
      uiMessage: uiMessage || "Please upload a valid CSV file.",
      fileError,
      validationErrors: [],
    };
  }

  // Row/field validation errors: [{ row, field, message }, ...]
  if (Array.isArray(error)) {
    return {
      success: false,
      uiMessage: uiMessage || "Please fix the CSV errors and try again.",
      fileError: null,
      validationErrors: error.map((item) => ({
        row: item.row != null ? item.row : null,
        field: item.field || null,
        message: item.message || "Invalid value",
      })),
    };
  }

  return {
    success: false,
    uiMessage: uiMessage || "Failed to create bulk orders",
    fileError: null,
    validationErrors: [],
  };
};

export const formatValidationErrorLine = ({ row, field, message }) => {
  const parts = [];
  if (row != null) {
    parts.push(`Row ${row}`);
  }
  if (field) {
    parts.push(field);
  }
  const prefix = parts.length ? `${parts.join(" · ")}: ` : "";
  return `${prefix}${message}`;
};
